export default __webpack_public_path__ + "static/media/026-pollution.6369939d.svg";